<template>
	<div id="app">
		<!-- Navigation -->	
		<Navigation></Navigation>		
	
		<!-- Header -->
		<Header></Header>	

		<!-- Various site sections -->
		
		<!-- Informatique (savoir plus) -->
		<Informatique></Informatique>	
		
		<br><br><br>

		<hr>
			
		<!-- Technicien informatique -->	  
		<Technicien></Technicien>

		<!-- Développement Logiciel -->
		<Logiciel></Logiciel>
		
		<!-- Développement Web -->
		<Web></Web>
		
		<!-- Administrateur Réseau -->
		<Administrateur></Administrateur>
		  
		<!-- Administrateur de Base de données -->
		<Dba></Dba>		 

		<!-- Footer -->
		<Footer></Footer>			
	</div>
</template>

<script>
import Navigation from './components/Navigation'
import Header from './components/Header'
import Informatique from './components/Informatique'
import Technicien from './components/Technicien'
import Logiciel from './components/Logiciel'
import Web from './components/Web'
import Administrateur from './components/Administrateur'
import Dba from './components/Dba'
import Footer from './components/Footer'
import Confidentialite from './components/Confidentialite'

export default {
  name: 'app',
  components:{
    Navigation,
	Header,
	Informatique,
	Technicien,
	Logiciel, 
	Web,
	Administrateur,
	Dba,
	Footer,
	Confidentialite
  }  
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
